module.exports = function (context) {
  var ret = {};
  
  //Takéto vracanie kvôli pomlčke vo viacslovnom názve form-fields
  ret['fields-form'] = require('./fields-form');

  return ret;
};

